import React, { useState, useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import styled from 'styled-components'

import { toggleMenu, listMenu, updateMenuStack, clearPage } from '../../_actions'
import { useWindowSize } from '../../_helpers'
import {
    devices,
    minDevices,
    colors,
    UpperHeader,
    Button,
    LeftArrow,
    MobileLogo,
    Logo,
} from '../Common'


export const Nav = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const { menu, menuOpen, menuStack } = useSelector(state => state.content)
    const { width } = useWindowSize()
    const mobile = width < 480
    const [activeImage, setActiveImage] = useState(null)
    const [orientation, setOrientation] = useState('')

    useEffect(() => {
        dispatch(listMenu())
    }, [])

    const openMenuPanel = () => {
        dispatch(toggleMenu(!menuOpen))
        document.body.style.overflow = menuOpen ? 'visible' : 'hidden'
    }

    // close individual menuItem
    const changeLocation = location => e => {
        e.preventDefault()
        if (!location) return
        if (location !== history.location.pathname) {
            history.push(location)
            dispatch(clearPage())
        }
        closePanel()
    }

    // Hide the entire side menu
    const closePanel = () => {
        dispatch(toggleMenu(false))
        document.body.style.overflow = 'visible'
    }

    const menuDown = (menuItem) => {
        menuStack.push(menuItem)
        dispatch(updateMenuStack(menuStack))
    }

    const menuUp = () => {
        menuStack.pop()
        dispatch(updateMenuStack(menuStack))
    }

    const setImage = (item) => {
        setActiveImage(item.first_image)
        setOrientation(item.image_orientation)
    }

    const NavItems = ({ list }) => list.map(item =>
        <NavItem
            key={item.title}
            as={item.children.length === 0 ? Link : ''}
            to={item.children.length === 0 ? item.linked_page : ''}
            onClick={item.children.length === 0 ? changeLocation(item.linked_page) : () => menuDown(item)}
            onMouseEnter={() => item.first_image !== null ? setImage(item) : ''}
        >
            {item.title}
        </NavItem>
    )

    const Buttons = () => (
        <ButtonContainer>
            <CloseButton role='button' aria-label='Close Menu' onClick={closePanel} />
            {menuStack.length ? <BackButton onClick={menuUp}> <LeftArrow /> {!mobile && 'PREVIOUS SCREEN'}</BackButton> : ''}
        </ButtonContainer>
    )

    const Hamburger = () => (
        <MenuButton role='button' open={menuOpen} onClick={openMenuPanel}>
            <div>
                <div />
                <div />
                <div />
            </div>
        </MenuButton>
    )

    return (
        <NavigationWrap open={menuOpen}>
            <OuterContainer>
                <Hamburger />
                {(mobile && menuOpen) && <Buttons />}
                {!mobile ? <Logo role='button' onClick={changeLocation('/')} /> : <MobileLogo role='button' onClick={changeLocation('/')} />}
            </OuterContainer>
            <InnerContainer>
                {!mobile && <Buttons />}
                <Menu>
                    <MenuScroll>
                        <MenuTitle marginbottom={30} fontSize={mobile ? 44 : 56}>{menuStack.length ? menuStack[menuStack.length - 1].title : 'Menu'}</MenuTitle>
                        <NavItems list={menuStack.length ? menuStack[menuStack.length - 1].children : menu} />
                    </MenuScroll>
                    {activeImage && <NavImage src={activeImage} orientation={orientation} />}
                </Menu>
            </InnerContainer>
        </NavigationWrap>
    )
}

const OuterContainer = styled.div`
    width: 85px;
    position: relative;

    @media ${devices.small} {
        width: 100%;
        height: 76px;
        display: flex;
        justify-content: space-between;
        /* align-items: center; */
    }
`

const InnerContainer = styled.div`
    height: 100%;
    padding: 0 40px;
    flex: 1 0 auto;

    @media ${devices.small} {
        padding: 0;
        margin-top: 50px;
    }
`

const NavImage = styled.div`
    background: url(${({ src }) => src}) center/cover no-repeat;
    width: 40%;
    height: 0;
    padding-bottom: ${props => props.orientation === 'portrait' ? '56.25%' : '26.25%'};
    border: 7px solid white;

    ${props => props.orientation === 'landscape' && `align-self: center;`}
`

const ButtonContainer = styled.div`
    display: flex;
    margin-bottom: 30px;

    @media ${devices.small} {
        position: absolute;
    }
`

const BackButton = styled(Button)`
    display: flex;
    align-items: center;
    font-size: 14px;
    padding: 10px 15px 9px;

    @media ${devices.small} {
        padding: 9px;
    }
`

const CloseButton = styled.div`
    width: 40px;
    height: 40px;
    background: url('/static/images/sprite.svg') no-repeat  -79px -78px;
    border: 1px solid ${colors.white};
    border-radius: 50%;
    margin-right: 10px;
    cursor: pointer;
`

const NavigationWrap = styled.nav`
    display: flex;
    flex-direction: row;
    /* justify-content: space-between; */
    background: ${colors.red};
    height: 100vh;
    width: calc(75vw + 50px);
    /* cursor: pointer; */
    position: fixed;
    left: 0;
    flex: 1;
    padding: 4vh 2vw;
    background: ${colors.pink};
    color: ${colors.white};

    @media ${devices.small} {
        width: 100%;
        transition: height 0.8s ease-out;
        height: ${props => props.open ? '100vh' : '5vh'};
        padding: 15px;
        flex-direction: column;
    }

    @media ${minDevices.medium} {
        z-index: 0;
    }
`

const Menu = styled.div`
    display: flex;
    justify-content: space-between;
    height: 86%;
    overflow-x: hidden;

    @media (max-width: 1450px) {

    }

    @media ${devices.small} {
        padding: 30px 0 0 0;
        margin-bottom: auto;
    }
`

const MenuScroll = styled.div`
    overflow: auto;
    /* hide scrollbar */
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
`

const NavItem = styled.div`
    font-size: 24px;
    cursor: pointer;
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
    text-decoration: none;
    color: ${colors.white};
    margin-bottom: 10px;

    &:after {
        content: '';
        display: block;
        background: url('/static/images/sprite.svg') no-repeat -85px -55px;
	    width: 23px;
	    height: 20px;
        margin-left: 20px;
        opacity: 0;
        transition: all 0.2s ease-in;
    }

    &:hover {
        &:after {
            opacity: 1;
        }
    }

    @media ${devices.small} {
        font-size: 22px;
        padding-left: 0;
        margin-bottom: 0;
        padding-bottom: 10px;
    }
`

const MenuButton = styled.div`
    display: flex;
    height: 32px;
    cursor: pointer;
    margin-left: -1vw;
    color: ${colors.white};
    visibility: ${({ open }) => open ? 'hidden' : 'visible'};

    > div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 35px;
        height: 35px;

        > div {
            height: 3px;
            margin: 3px 0;
            background: ${colors.white};
        }
    }

    @media ${devices.small} {
        height: 21px;
        margin-right: 10px;
        > div {
            height: 21px;
        }
    }

    @media ${devices.medium} {
        margin-left: 0;
    }
`

const MenuTitle = styled(UpperHeader)`
`
